import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ toastOptions, ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      position="bottom-center"
      toastOptions={{
        duration: 1950,
        classNames: {
          toast: "bg-blue-brand/10! backdrop-blur-md! mb-[5em]! text-white! border-0! shadow-xs! w-fit! mx-auto!",
          description: "text-white/10!",
          actionButton: "bg-white/20! text-white!",
          cancelButton: "bg-white/10! text-white/70!",
          success: "text-white! [&_svg]:text-white/10! bg-blue-brand/10!",
          error: "text-white! [&_svg]:text-white/10! bg-blue-brand/10!",
          warning: "text-white! [&_svg]:text-white/10! bg-blue-brand/10!",
          info: "text-white! [&_svg]:text-white/10! bg-blue-brand/10!",
        },
        ...toastOptions,
      }}
      {...props}
    />
  )
}

export { Toaster }
